// extracted by mini-css-extract-plugin
module.exports = {"about-page":"about-page--X2PM-","about-page__foreign":"about-page__foreign--Ap0dE"};